export default __webpack_public_path__ + "media/images/brands/xpress/other/about_us-1230d12c27d818041e5192dda4a0ce2e.jpg";